import { SearchFilter, SearchFilterType } from '../types';

export function useFilterItemsNotOfType(
  filter: SearchFilter,
  type: SearchFilterType[],
  excludeFields: string[]
) {
  return filter.items?.filter(
    (x) => !type.includes(x.type) && !excludeFields.includes(x.field!)
  );
}
